<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
       @change_language="handleHeaderClick"
      ></HeaderComponent>
      <img
        src="/assets/images/about/Header.png"
        class="img-fluid w-100 d-block"
        alt=""/>
    <div class="container-fluid px-0">
      <div class="row align-items-stretch">
        <!-- Changed align-items-center to align-items-stretch -->
        <div
          class="col-md-6 d-flex align-items-center py-4"
          style="background: #4885ed"
        >
          <div class="px-3 py-4">
            <h3 class="text-white text-center">
             {{ pageContent.des }} 
            </h3>
          </div>
        </div>
        <div
          class="col-md-6"
          style="
            background: url('/assets/images/about/Body1.png') no-repeat center
              center;
            background-size: cover;
          "
        ></div>
      </div>
    </div>

    <!-- <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background-image: url(/assets/images/about/Body2.png);
        background-size: cover;
        background-position: center;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <div
          class="dz-bnr-inr-entry"
          style="
            background-color: rgba(
              255,
              255,
              255,
              0.9
            ); /* White with 80% opacity */
            padding: 50px;
            border-radius: 10px;
            color: black;
          "
        >
          <h1 class="text-left text-primary">Our Mission & Vision</h1>
          <br />
          <p style="font-size: 20px">
            We are a global platform powered by AI technology to connect
            educators with schools that match their skills, values, and
            aspirations. Our mission is to simplify recruitment, providing
            schools with efficient access to a global network of qualified
            educators. We are committed to offering educators comprehensive
            support, including relocation assistance, housing resources, and
            visa guidance, ensuring a smooth transition to their new roles.<br /><br />

            We aim to be the leading partner in connecting global educators with
            U.S. schools, fostering a more diverse and inclusive education
            system. Our vision is to support educators at every step, empowering
            them to inspire students and communities worldwide.
          </p>
        </div>
      </div>
    </div> -->
    <br />
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h2 class="text-left text-primary mb-0" style="color: #0c27bd">
            {{ pageContent.mission }}
          </h2>
          <h3 class="text-primary" style="font-weight: 300">
            {{ pageContent.founder }}
          </h3>
          <div style="padding-right: 50px">
            <p class="text-justify" style="font-size: 18px;color:#00609e;">
               {{ pageContent.founder_des }}<br><br>
               {{ pageContent.founder_des2 }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <img
            src="/assets/images/about/Founders.png"
            class="img-fluid"
            alt="Founders"
          />
        </div>
      </div>
    </div>
    <br />
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background-image: url(/assets/images/about/Body3.png);
        background-size: cover;
        background-position: center;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <div
          class="dz-bnr-inr-entry"
          style="
            background-color: rgba(
              255,
              255,
              255,
              0.9
            ); /* White with 80% opacity */
            padding: 50px;
            border-radius: 10px;
            color: black;
          "
        >
          <br />
          <h2 class="text-primary" style="font-weight: 400">
            {{ pageContent.together }}
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <img
            src="/assets/images/Explore2Teach_Logo.png"
            class="img-fluid d-block mx-auto"
            alt=""
          />
          <div class="teaching-journey">
            <h4 class="text-center" style="font-weight: 300;">
              {{ pageContent.areyou }}
            </h4>
            <center>
              <button class="btn btn-primary" @click="goToRegister()">
                {{ pageContent.register }}
              </button>
            </center>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<style>
.teaching-journey {
  margin-top: -80px;
}

@media (max-width: 991px) {
  .teaching-journey {
    margin-top: -40px;
  }
}
@media (max-width: 767px) {
  .teaching-journey {
    margin-top: -20px;
  }
}
</style>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "AboutUs",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data(){
    return {
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    }
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    goToRegister() {
      window.location = "/user/register";
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.aboutUs[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      } else {
        console.warn(`No translations found for lang: ${lang}`);
      }

      console.log("Updated content:", this.pageContent);
    },
  },
};
</script>